import React, { useState } from "react";
import { Button, Modal, Row, Col } from "reactstrap";
import "./subscribe-modal.css";
import { useNavigation } from '../../../shared/utils/useNavigation';
import { customConfirm, showError, showLoading, closeAlert } from "../../../shared/utils/swalHandler";
import { showSubscriptionCancelledPushToast } from "../../../shared/pusNotification/useManualToasts";
import { unsubscribe as unsubscribeAction } from "../../../shared/actions/subscriptionAction";
import { PURCHASE_STATE, SUBSCRIPTION_STATUS_REFRESH_DELAY_MS } from '../../../shared/constants/common';

function UnsubscriptionModalInProgress({ userInfo, handleCallback = () => {} }) {
  const navigate = useNavigation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const unSubscribe = async () => {
    const ccId = userInfo?._id;
    const username = userInfo?.username;
    if (!ccId || !username) {
      await showError(
        "Error",
        "Creator information is missing. Please refresh and try again.",
        { confirmButtonColor: "#F334BE" }
      );
      return;
    }

    const subscriptionState = userInfo?.subscription?.state;

    const confirmText = subscriptionState === PURCHASE_STATE.PENDING
      ? "Payment confirmation is in progress. Cancel anyway?"
      : "You will not be refunded and you will lose access to this account.";

    const isConfirmed = await customConfirm(
      `Unsubscribe from @${username}?`,
      confirmText,
      "Unsubscribe",
      "Cancel",
      { confirmButtonColor: "#6c757d", cancelButtonColor: "#f334be" }
    );

    if (!isConfirmed) return;

    try {
      showLoading("Cancelling subscription...");
      const result = await unsubscribeAction(ccId, subscriptionState === PURCHASE_STATE.PENDING ? true : false);

      if (result && result.success) {
        const successMessage =
          result.data?.message || "This subscription has been successfully canceled.";
        closeAlert();
        showSubscriptionCancelledPushToast(userInfo, successMessage);
        setIsModalOpen(false);
        await new Promise((resolve) => setTimeout(resolve, SUBSCRIPTION_STATUS_REFRESH_DELAY_MS));
        await handleCallback();
      } else {
        closeAlert();
        const errorMessage = result?.error || "Something went wrong. Please try again.";
        await showError(
          "Error",
          errorMessage,
          { confirmButtonColor: "#F334BE" }
        );
      }
    } catch (error) {
      closeAlert();
      await showError(
        "Error",
        "Something went wrong. Please try again.",
        { confirmButtonColor: "#F334BE" }
      );
    }
  };

  const handleToTransactions = () => {
    navigate.toTransactions();
  };

  return (
    <>
      <Button
        style={{ textTransform: "unset", marginBottom: "17px" }}
        className="btn-round subscribe-btn"
        color="warning"
        outline
        type="button"
        onClick={toggleModal}
      >
        Unsubscription in progress...
      </Button>

      <Modal
        isOpen={isModalOpen}
        toggle={toggleModal}
        centered
        className="subscribe-modal subs-modal logged-in"
        style={{ overflow: "hidden" }}
      >
        <Row>
          <Col className="subscribe-modal-left-side">
            <div className="modal-body d-flex flex-column justify-content-between">
              <h4 className="text-center mt-0">Subscription Status</h4>
              <div className="mb-4 text-center">
                @{userInfo.username}
              </div>
              <Col sm="10" md="mb-5" className="mx-auto text-center">
                <i className="fa fa-warning"></i> Awaiting payment cancellation.
                <br />
                <small>
                  *It will be updated automatically in a few minutes.
                </small>
              </Col>
              <br />
              <Col sm="10" md="mb-5" className="mx-auto">
                <div
                  onClick={handleToTransactions}
                  style={{ textAlign: "center" }}
                >
                  Click to see more information
                </div>
                <br />
                <br />
              </Col>
              <Button
                className="btn-sm btn-link text-center text-danger"
                onClick={unSubscribe}
              >
                Retry cancel this subscription
              </Button>
              <Button
                block
                className="btn-round py-2 my-2 mx-auto"
                color="default"
                onClick={toggleModal}
                style={{ width: "100%" }}
              >
                Close
              </Button>
            </div>
          </Col>
        </Row>
      </Modal>
      <br />
    </>
  );
}

export default UnsubscriptionModalInProgress;
